import { Component, ElementRef, ViewChild } from '@angular/core';
import { PlanFilterService } from './plan-filter.service';
import { Subscription } from 'rxjs';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { ToolbarModule } from 'primeng/toolbar';


@Component({
    selector: 'app-plan-filter',
    imports: [CheckboxModule, ButtonModule, SelectButtonModule, FormsModule, IconField, InputIcon, ToolbarModule, InputTextModule],
    template: `
    <p-toolbar>
    <ng-template #start>
    <p-iconfield class="w-full">
                            <p-inputicon class="pi pi-search" />
                            <input pInputText type="text" placeholder="Search" class="w-full" (input)="onSearch($event)"/>
                        </p-iconfield>

    </ng-template>
    <ng-template #center>
    <p-selectButton [options]="planFilterService.distinctCollections()"
      [(ngModel)]="planFilterService.selectedCollectionString"
      (onChange)="planFilterService.onSelectCollection($event.value)" />
    </ng-template>
    <ng-template #end>
    <p-checkbox inputId="archived" [binary]="true" [(ngModel)]="planFilterService.includeArchived" (onChange)="planFilterService.setIncludeArchived($event.checked)"></p-checkbox>
      <span class="ml-2 text-900">{{planFilterService.includeArchived() ? 'Archived Plans Included' :
        'Archived Plans Excluded'}}</span>
        <p-button icon="pi pi-times" class="ml-4" severity="danger" (onClick)="onCloseSearch()" text></p-button>
    </ng-template>
</p-toolbar>

  `,
    styles: [`
    :host {
    display: block;
    width: 100%;
}

.grid {
    width: 100%;
}

.formgrid {
    width: 100%;
}
  `]
})
export class PlanFilterComponent {
  isDark = false;
  filterOpen = false;
  isDialogOpen = false;
  sialogSubscription!: Subscription;

  @ViewChild('searchInput') searchInputElement!: ElementRef;

  constructor(
    public planFilterService: PlanFilterService
  ) { }

  onSearch(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const query = inputElement?.value ?? '';
    this.planFilterService.searchPlans(query);
  }

  toggleFilter() {
    this.filterOpen = !this.filterOpen;
  }

  onCloseSearch() {
    this.planFilterService.setDialogOpen(false);
  }

  getShortcutPrefix(letter: string) {
    // return this.shortcutHandlerService.getShortcutPrefix(letter);
  }

  focusOnSearchInput() {
    this.searchInputElement.nativeElement.focus();
  }
}



